import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const ActivityConflictWarning = ({ conflicts = [], acknowledged, onAcknowledge }) => {
  if (conflicts.length === 0) return null;

  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 space-y-3">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-amber-100 text-amber-700 flex items-center justify-center shrink-0">
          <SafeIcon icon="⚠️" className="w-4 h-4" />
        </div>
        <div>
          <h4 className="text-xs font-black text-amber-900 uppercase tracking-widest">
            Tidskonflikt oppdaget
          </h4>
          <p className="text-xs text-amber-800 mt-1">
            Tidspunktet overlapper med {conflicts.length === 1 ? 'en annen aktivitet' : `${conflicts.length} andre aktiviteter`}.
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {conflicts.slice(0, 3).map(conflict => (
          <div
            key={conflict.activity_id}
            className="bg-white/70 border border-amber-100 rounded-lg px-3 py-2"
          >
            <div className="flex items-center justify-between gap-3">
              <span className="text-xs font-bold text-slate-800 truncate">
                {conflict.title || 'Aktivitet uten tittel'}
              </span>
              <span className="text-[10px] font-black text-amber-700 whitespace-nowrap">
                {new Date(conflict.date).toLocaleTimeString('no-NO', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </span>
            </div>
            <p className="text-[10px] text-slate-500 mt-1">
              {conflict.type || 'Aktivitet'}
            </p>
          </div>
        ))}

        {conflicts.length > 3 && (
          <p className="text-[10px] font-bold text-amber-800">
            + {conflicts.length - 3} flere konflikter
          </p>
        )}
      </div>

      {!acknowledged ? (
        <button
          type="button"
          onClick={onAcknowledge}
          className="w-full px-4 py-2.5 bg-amber-600 text-white rounded-lg text-[10px] font-black uppercase tracking-widest hover:bg-amber-700 transition-colors"
        >
          Fortsett likevel
        </button>
      ) : (
        <div className="flex items-center gap-2 text-[10px] font-bold text-amber-800">
          <SafeIcon icon="✓" className="w-3 h-3" />
          Konflikten er bekreftet. Aktiviteten kan lagres.
        </div>
      )}
    </div>
  );
};

export default ActivityConflictWarning;